import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {Dialog} from '../luci-dialog/luci-dialog.model';
import {SortOptions, SortInfo} from './luci-table-multi-column-sorting.interface';
import {IDropDownOptions} from '../luci-dropdown/luci-dropdown.model';
import {ITableHeader} from '../luci-table/luci-table.model';

@Component({
  selector: 'luci-table-multi-column-sorting',
  templateUrl: './luci-table-multi-column-sorting.component.html',
  styleUrls: ['./luci-table-multi-column-sorting.component.scss']
})
export class LuciTableMultiColumnSortingComponent implements OnInit, OnChanges {
  @Input() dialog: Dialog;
  @Input() tableSettingHeader: ITableHeader[] = [];
  @Input() ownTemplate = true;
  @Input() defaultFooter = false;

  @Input() isMultiColumnSortingOpen = false;
  @Output() updateSortConfiguraiton: EventEmitter<any> = new EventEmitter();



  public availableList: ITableHeader[] = [];
  public selectedList: ITableHeader[] = [];
  public expandList: ITableHeader[] = [];
  public minSelectValue = 3;
  public disabledList = {
    selectedCheckbox: false,
    availableCheckbox: false,
    upBtn: false,
    downBtn: false
  };

  collapseBtn = 'collapse';
  expandBtn = 'expand';

  applyBtnText = 'Apply';
  isApplyBtnPrimary = true;
  resetBtnText = 'Reset';
  isResetBtnPrimary = true;


  sortOptions: IDropDownOptions[] = SortOptions;
  columnOptions: IDropDownOptions[] = [];
  sortInfo: SortInfo[] = [{key: '', value: ''}];


  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.tableSettingHeader) {
        this.columnOptions = [];
        this.tableSettingHeader.forEach(element => {
            this.columnOptions.push({
                id: element.id,
                name: element.name,
                value: element.key
            });
        });
    }
  }


  updateSortInfo($event, type, i) {
    if (type === 'column') {
        this.sortInfo[i].key = $event;
    } else if (type === 'sortOption') {
        this.sortInfo[i].value = $event;
    }
  }

  addSortInfo() {
      this.sortInfo.push({key: '', value: ''});
  }

  removeSortInfo(index) {
    this.sortInfo.splice(index, 1);
  }

  resetToDefault() {
    this.sortInfo = [{key: '', value: ''}];
  }

  saveConfiguration() {
    this.updateSortConfiguraiton.emit(this.sortInfo);
    this.closeDialog();
  }

  isValidSelection() {
    let inValid = false;
    this.sortInfo.map(function(obj) {
        return obj.key;
    }).forEach(function(element, index, arr) {
        if (arr.indexOf(element) !== index || element === '') {
            inValid = true;
        }
    });

    return inValid;
  }

  closeDialog() {
    this.isMultiColumnSortingOpen = false;
  }


}
